import { axiosInstance } from './axiosInstance';
import axios from 'axios';



export const list = async (db) => {
    try {
        const response = await axiosInstance.get('/api/v1/adminpanel/news/list');
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const fetchDataByID = async (ID) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/news/${ID}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
}

export const addNews = async (data, id = "") => {
    try {
        let response;
        if (id) {
            response = await axiosInstance.put(`/api/v1/adminpanel/news/edit/${id}`, data);
        } else {
            response = await axiosInstance.post(`/api/v1/adminpanel/news/add`, data);
        }

        return response;
    } catch (error) {
        return error;
    }
}

export const deleteNewsByID = async (ID) => {
    try {
        const response = await axiosInstance.delete(`/api/v1/adminpanel/news/delete/${ID}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

